import {AfterViewInit, Component, OnInit} from '@angular/core';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, AfterViewInit {
  protected dashboardItems = {};
  public objectKeys = Object.keys;
  constructor(protected dashboardService: DashboardService) {
  }

  ngOnInit() {
      console.log('called dashboard onInit lifecycle');
      this.dashboardService.getDashboardItems().subscribe({
          next: (val) => {
              console.log('setting dashboardItems to:', val);
              this.dashboardItems = val;
          }
      });
  }
    ngAfterViewInit() {
      console.log('called afterViewInit');
    }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts